import { useTranslation } from 'react-i18next';

import {
  LocationContainer,
  RowWrapper,
  Divider,
  Wrapper,
  Title,
  Code,
  Time,
  Item,
  Name,
  Value,
} from './Location.style';

const Location = ({
  direction,
  time: {
    [direction]: { actual, estimated, scheduled, takeoff, landing },
  },
  location,
  airport: { departureGate, departureTerminal, arrivalGate, arrivalTerminal },
  isSameDate,
}) => {
  const { t } = useTranslation();
  const terminal =
    direction === 'arrival' ? arrivalTerminal : departureTerminal;
  const gate = direction === 'arrival' ? arrivalGate : departureGate;

  return (
    <LocationContainer>
      <RowWrapper>
        <Wrapper>
          <Title variant="p">{location?.city}</Title>
          <Code variant="h6" style={{ fontSize: '24px' }} color="primary">
            {location?.fs}
          </Code>
        </Wrapper>
        <Wrapper time_text="true">
          <Title variant="p">
            {actual
              ? t(`flightstatus.details.actual${direction}`)
              : estimated
              ? t(`flightstatus.details.estimated${direction}`)
              : t('flightstatus.details.scheduled')}
          </Title>
          <Time>{`${actual || estimated || scheduled}${
            direction === 'arrival' && !isSameDate ? ' (+1)' : ''
          }`}</Time>
        </Wrapper>
      </RowWrapper>
      <Divider />
      <RowWrapper>
        <Wrapper>
          <Item>
            <Name variant="p" airport="true">
              Terminal
            </Name>
            <Value variant="p">{terminal || '-'}</Value>
          </Item>
          <Item>
            <Name variant="p" airport="true">
              Gate
            </Name>
            <Value variant="p">{gate || '-'}</Value>
          </Item>
        </Wrapper>
        <Wrapper>
          <Item>
            <Name variant="p">{t('flightstatus.details.scheduled')}</Name>
            <Value variant="p">{`${scheduled || '-'}${
              direction === 'arrival' && scheduled && !isSameDate ? ' (+1)' : ''
            }`}</Value>
          </Item>
          <Item>
            <Name variant="p">
              {direction === 'arrival'
                ? t('flightstatus.details.touchdown')
                : t('flightstatus.details.left')}
            </Name>
            <Value variant="p">
              {`${(direction === 'arrival' ? landing : actual) || '-'}${
                direction === 'arrival' && (landing || actual) && !isSameDate
                  ? ' (+1)'
                  : ''
              }`}
            </Value>
          </Item>
          <Item>
            <Name variant="p">
              {direction === 'arrival'
                ? t('flightstatus.details.gatearrival')
                : t('flightstatus.details.takeoff')}
            </Name>
            <Value variant="p">
              {`${(direction === 'arrival' ? actual : takeoff) || '-'}${
                direction === 'arrival' && (actual || takeoff) && !isSameDate
                  ? ' (+1)'
                  : ''
              }`}
            </Value>
          </Item>
        </Wrapper>
      </RowWrapper>
    </LocationContainer>
  );
};

export default Location;
